import React from 'react';
import Pdfgenerator from './Pdfgenerator';

const ChatInput = ({
                       inputValue,
                       setInputValue,
                       handleSend,
                       handleImageChange,
                       pdfStats,
                       messages,
                       sentImageUrls,
                       setShowForm,
                       setShowModal,
                       setIsOver
                   }) => {
    return (
        <div className="bg-blue-300 relative">
            <form
                className="py-5 px-4 m-auto flex flex-row w-full fixed bottom-0 left-0 right-0 border-2 border-black"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSend(e, inputValue);
                }}
            >
                <input
                    className={`w-full rounded-lg border-[1px] border-[#DD6E79] h-14 m-auto bg-grey-400 pl-28 pr-20 text-[#3D5A80] ${pdfStats.remaining < 1 ? 'bg-gray-300 text-white' : ''} `}
                    readOnly={pdfStats.remaining < 1}
                    name="question"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Posez vos questions ici"
                />
                {/*<textArea*/}
                {/*    className={`w-full rounded-lg border-[1px] border-[#DD6E79]  m-auto bg-grey-400 pl-28 pr-20 text-[#3D5A80] ${pdfStats.remaining < 1 ? 'bg-gray-300 text-white' : ''} `}*/}
                {/*    readOnly={pdfStats.remaining < 1}*/}
                {/*    name="question"*/}
                {/*    value={inputValue}*/}
                {/*    onChange={(e) => setInputValue(e.target.value)}*/}
                {/*    placeholder="Posez vos questions ici"*/}
                {/*    rows={5}*/}
                {/*/>*/}
                <div className="m-auto flex flex-row">
                    <button type="submit" className="w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2F4F6F"
                             className="w-9 h-9 text-gray-500 hover:text-gray-800 absolute bottom-8 right-8">
                            <path
                                d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"/>
                        </svg>
                    </button>
                     
                </div>
                <div>
                  <input
                        type="file"
                        id="file"
                        name="file"
                        accept="image/png, image/jpeg, .doc, .pdf"
                        onChange={handleImageChange}
                        multiple={true}
                        className="hidden"
                    />
                  <label htmlFor="file" className="w-auto absolute left-6 bottom-8">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="#2F4F6F" className={`w-9 h-9`}>
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"/>
                        </svg>
                    </label>
                </div>
            </form>
        </div>
    );
};

export default ChatInput;